import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import {
  getLabelConfigurationWarningModeFromACU,
  getPoolMasterClass,
} from '../../../../../../ECoSystemsHelper';
import { P00032 } from '../../../../P00032';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import {
  LabelConfigurationComponent,
  LabelConfigurationWarningMode,
} from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { P00037ESPInstallationClComponent } from '../../../EnSavoirPlus/p00037-espinstallation-cl/p00037-espinstallation-cl.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { InformationTitleComponent } from '../../../../../../../../components/ecosystems/information-title/information-title.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import { P00037ConsigneManuel } from '../../../Enum/P00037ConsigneManuel';
import { P00037ConsigneRegulationRxEnum } from '../../../Enum/P00037ConsigneRegulationRx';
import { P00037TauxAbaissement } from '../../../Enum/P00037TauxAbaissement';
import { P00037HysteresisRegulationRx } from '../../../Enum/P00037HysteresisRegulationRx';
import { FunctionParametersSettingsClockSaltScreenComponent } from '../../../Component/function-parameters-settings-clock-salt-screen/function-parameters-settings-clock-salt-screen.component';
import { FunctionParametersSettingClockWeekSaltScreenComponent } from '../../../Component/function-parameters-setting-clock-week-salt-screen/function-parameters-setting-clock-week-salt-screen.component';

@Component({
  selector: 'app-p00037-electrolyseur-mise-en-oeuvre-desinfection',
  templateUrl:
    './p00037-electrolyseur-mise-en-oeuvre-desinfection.component.html',
  styleUrls: [
    './p00037-electrolyseur-mise-en-oeuvre-desinfection.component.scss',
  ],
  imports: [
    HeaderConfigurationComponent,
    InformationTitleComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    SwitchConfigurationComponent,
    TranslatePipe,
    TwoChoicesControlComponent,
  ],
})
export class P00037ElectrolyseurMiseEnOeuvreDesinfectionComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalService: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  getPool(): Pool {
    return this.edroNetworkManager.getPoolContext().pool!;
  }

  constructor() {
    this.P00037ESPInstallationClModal =
      this.P00037ESPInstallationClModal.bind(this);
    this.openEnSavoirPlus = this.openEnSavoirPlus.bind(this);
  }

  hasProduitP00032() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00032()) ?? 0;
  }

  async P00037ESPInstallationClModal() {
    const modal = await this.slideModalService.create({
      component: P00037ESPInstallationClComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  async openEnSavoirPlus() {
    const modal = await this.slideModalService.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description: 'P00037.programmation.ensavoirplus',
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockSaltScreenComponent,
      componentProps: {
        value: [
          this.actionStack!.getValue('elPHorlogeLundi'),
          this.actionStack!.getValue('elPHorlogeMardi'),
          this.actionStack!.getValue('elPHorlogeMercredi'),
          this.actionStack!.getValue('elPHorlogeJeudi'),
          this.actionStack!.getValue('elPHorlogeVendredi'),
          this.actionStack!.getValue('elPHorlogeSamedi'),
          this.actionStack!.getValue('elPHorlogeDimanche'),
        ],
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage2,
        'elPHorlogeLundi',
        hj[0],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage2,
        'elPHorlogeMardi',
        hj[1],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage3,
        'elPHorlogeMercredi',
        hj[2],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage3,
        'elPHorlogeJeudi',
        hj[3],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage4,
        'elPHorlogeVendredi',
        hj[4],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage4,
        'elPHorlogeSamedi',
        hj[5],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage5,
        'elPHorlogeDimanche',
        hj[6],
        null,
      );
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekSaltScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('elPHorlogeSemaine'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Parametrage5,
        'elPHorlogeSemaine',
        hj,
        null,
      );
    }
  }

  getProductDeviceTableFromPool() {
    const pool = this.edroNetworkManager.getPoolContext().pool!;
    const master = getPoolMasterClass(pool);
    return master!.getProductDeviceTableFromPool(pool!).firmwareVersion < 6
      ? LabelConfigurationWarningMode.NEED_UPDATE
      : master!.getProductDeviceTableFromPool(pool!).firmwareVersion == 6
        ? LabelConfigurationWarningMode.NEW
        : LabelConfigurationWarningMode.NONE;
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;

  protected readonly P00037ConsigneManuel = P00037ConsigneManuel;
  protected readonly P00037ConsigneRegulationRxEnum =
    P00037ConsigneRegulationRxEnum;
  protected readonly P00037HysteresisRegulationRx =
    P00037HysteresisRegulationRx;
  protected readonly getLabelConfigurationWarningModeFromACU =
    getLabelConfigurationWarningModeFromACU;
  protected readonly P00037TauxAbaissement = P00037TauxAbaissement;
}
